import { render, staticRenderFns } from "./storeCompetition.vue?vue&type=template&id=8af29e32&scoped=true"
import script from "./storeCompetition.vue?vue&type=script&lang=js"
export * from "./storeCompetition.vue?vue&type=script&lang=js"
import style0 from "./storeCompetition.vue?vue&type=style&index=0&id=8af29e32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af29e32",
  null
  
)

export default component.exports